
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/386d747c110470c1d8d7b875130433c7.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Transform Your Health<br />
            <span className="text-[#C8A2C8]">From the Inside Out</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-[#F0F0F0] max-w-4xl mx-auto">
            Peptide Therapy • Weight Loss • IV Therapy • Mental Health • Longevity
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" className="text-lg px-8 py-4" onClick={handleConsultationClick}>
              <i className="ri-calendar-line mr-2"></i>
              Book a Consultation
            </Button>
            <Button 
              variant="secondary" 
              size="lg" 
              className="text-lg px-8 py-4"
              onClick={() => window.open('tel:202-269-6600', '_self')}
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now
            </Button>
          </div>
          
          {/* Benefits */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-flashlight-line text-2xl text-white"></i>
              </div>
              <h3 className="font-semibold text-lg">Rapid Results</h3>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="font-semibold text-lg">Personalized Care</h3>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-stethoscope-line text-2xl text-white"></i>
              </div>
              <h3 className="font-semibold text-lg">Medical Expertise</h3>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="font-semibold text-lg">Safe & Effective</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
